import IRelevantSpecialist from './interfaces/IRelevantSpecialist'

export const Neuropsychologist: IRelevantSpecialist = {
  label: 'Neuropsychologist',
  href: '#'
}

export const EducationalPsychologist: IRelevantSpecialist = {
  label: 'Educational Psychologist',
  href: '#'
}

export const EducationalTherapist: IRelevantSpecialist = {
  label: 'Educational Therapist',
  href: '#'
}

export const OccupationalTherapy: IRelevantSpecialist = {
  label: 'Occupational Therapy',
  href: '#'
}

export const Neurologist: IRelevantSpecialist = {
  label: 'Neurologist',
  href: '#'
}

export const Physiotherapist: IRelevantSpecialist = {
  label: 'Physiotherapist',
  href: '#'
}

export const ClinicalPsychologist: IRelevantSpecialist = {
  label: 'Clinical Psychologist',
  href: '#'
}

export const BehavioralTherapist: IRelevantSpecialist = {
  label: 'Behavioral Therapist',
  href: '#'
}

export const Psychiatrist: IRelevantSpecialist = {
  label: 'Psychiatrist',
  href: '#'
}

export default {
  Neuropsychologist,
  EducationalPsychologist,
  EducationalTherapist,
  OccupationalTherapy,
  Neurologist,
  Physiotherapist,
  ClinicalPsychologist,
  BehavioralTherapist,
  Psychiatrist
}



// WEBPACK FOOTER //
// ./src/data/abitilies/relevantSpecialists.ts